import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Subcategory {
  id: string
  name: string
}

export interface UseSubcategoriesResult {
  subcategories: Subcategory[]
  loading: boolean
  error: string | null
  refetch: (categoryId?: string) => Promise<void>
}

export function useSubcategories(categoryId?: string): UseSubcategoriesResult {
  const [subcategories, setSubcategories] = useState<Subcategory[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (currentCategoryId?: string): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const url = currentCategoryId 
        ? `/admin/conversation-management/subcategories/dropdown?categoryId=${currentCategoryId}`
        : '/admin/conversation-management/subcategories/dropdown'
      console.log('Fetching subcategories from:', url)
      const res = await api.get<{ subcategories: Subcategory[] }>(url)
      console.log('Subcategories response:', res)
      setSubcategories(res.subcategories || [])
    } catch (e) {
      console.error('Failed to fetch subcategories:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch subcategories')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch(categoryId)
  }, [categoryId, refetch])

  return { subcategories, loading, error, refetch }
}
